<template lang="html">
  <div class="placed-backg contact-page-" id="page-info-t1">
    <div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.jpg)' }"></div>

    <section class="container oversized-container content-section">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-5 text-center col-info">
          <h1 class="mb-2 page-title">Contacto</h1>

          <!-- <p>
            Nos gustaría llevarte nuestro muestrario, regalarte un catálogo y platicarte sobre nuestros atractivos precios de mayoreo en persona.
          </p> -->
          <p class="mt-2">
            Escríbenos o llámanos para contactarnos.
          </p>

          <hr />
          <h5 class="subtitle-sm">Dirección:</h5>
          <p>
            Av. La Paz #5520<br />
            Centro, #44800<br />
            Guadalajara, Jalisco
          </p>

          <br />
          <h5 class="subtitle-sm">Correo  Electrónico:</h5>
          <p>
            <a href="mailto:contacto@dominio.com">contacto@dominio.com</a>
          </p>

          <!-- <iframe class="iframe-map" src="" allowfullscreen="" loading="lazy"></iframe> -->
        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <b-form @submit="onSubmit">
            <b-form-group class="custom-f-group">
              <b-form-input
                v-model="form.name"
                type="text"
                required
                placeholder="Nombre"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-f-group">
              <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Correo electrónico"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-f-group">
              <b-form-input
                v-model="form.state"
                type="text"
                required
                placeholder="Estado"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-f-group">
              <b-form-input
                v-model="form.cp"
                type="number"
                required
                placeholder="Código postal"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-f-group">
              <b-form-input
                v-model="form.phone"
                type="text"
                required
                placeholder="Teléfono"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-f-group">
              <b-form-textarea
                v-model="form.msg"
                placeholder="Mensaje"
                required
                rows="4"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-send btn-s2">Enviar</b-button>
            </p>
          </b-form>

        </div>
      </div>
    </section>

    <!-- <section class="container-fluid px-0 map-section">
      <iframe src="!2m3!1f0" allowfullscreen="" loading="lazy"></iframe>
    </section> -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        email: null,
        state: null,
        cp: null,
        phone: null,
        msg: null
      },
      info: [],
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/contact"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Mensaje enviado');
          this.form = {
            name: null,
            email: null,
            state: null,
            cp: null,
            phone: null,
            msg: null
          };
        }).catch( (error)=> {
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.cp, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
      });
    }
  },

  beforeMount(){
    // this.getInfo();

    if(this.$route.query.p){
      this.form.msg = 'Me interesa el producto '+ this.$route.query.p;
    }
  }
}
</script>
